import APP_FEATURES from "$/settings/app-features.json";
import PAID_FEATURES from "$/settings/paid-features.json";
import getEnums from "$/settings/enums";
import { useAuth } from "~/components/general";
import { useAppConfigStore } from "~/stores/appConfigStore";
import isPaidFeatureAvailable from "~/utils/isPaidFeatureAvailable";

const AppFeatures = getEnums(APP_FEATURES, "reference");
const PaidFeatures = getEnums(PAID_FEATURES, "reference");

export const useIsProductCatalogEnabled = () => {
  const appConfig = useAppConfigStore();
  return appConfig.features?.includes(AppFeatures.productCatalog);
};

export const useIsCompaniesContactsEnabled = () => {
  const appConfig = useAppConfigStore();
  return appConfig.features?.includes(AppFeatures.companiesContacts);
};

export const useIsCustomerPortalHierarchyEnabled = () => {
  const appConfig = useAppConfigStore();
  const { user } = useAuth();
  return isPaidFeatureAvailable(
    PaidFeatures.customerPortalHierarchy,
    user,
    appConfig,
  );
};

export const useIsAutoSaveEnabled = () => {
  const appConfig = useAppConfigStore();
  return appConfig.features?.includes(AppFeatures.autoSave);
};

export const useIsCreatePmWorkOrderEnabled = () => {
  const appConfig = useAppConfigStore();
  return !!appConfig.features?.includes(AppFeatures.createPmWorkOrder);
};

export const useIsAssetsCalendarViewEnabled = () => {
  const appConfig = useAppConfigStore();
  return !!appConfig.features?.includes(AppFeatures.assetsCalendarView);
};

export const useGetAppConfigValue = () => {
  const appConfig = useAppConfigStore();
  return appConfig;
};
